/* eslint-disable import/prefer-default-export */
export const getStorageURL = (bucketName: string, filename: string) =>
  `https://firebasestorage.googleapis.com/v0/b/${bucketName}/o/${encodeURIComponent(
    filename,
  )}?alt=media`;
